<template>
  <div
    :class="appWrapperClass"
    class="app-wrapper">
    <navbar />
    <sidebar />
    <div class="main-container">
      <!-- <tags-view></tags-view> -->
      <app-main />
    </div>
    <file-uploader-modal
      :show="isShowFileUploadModal"
      @close="setShowFileUploadModal(false)"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Navbar from './components/Navbar.vue'
import Sidebar from './components/Sidebar/index.vue'
import AppMain from './components/AppMain.vue'
import FileUploaderModal from '../../components/FileUploaderModal.vue'
// import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'MainLayout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    FileUploaderModal,
  },
  // mixins: [ResizeMixin],
  computed: {
    ...mapGetters({
      sidebar: 'app/sidebar',
      isShowFileUploadModal: 'file/isShowFileUploadModal',
    }),
    // device() {
    //   return this.$store.state.app.device
    // },
    appWrapperClass() {
      return {
        'hide-sidebar': !this.sidebar.isOpened,
        'without-animation': !this.sidebar.isAnimated,
        // mobile: this.device === 'mobile'
      }
    },
  },
  methods: {
    ...mapActions({
      setShowFileUploadModal: 'file/setShowFileUploadModal',
    }),
  },
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>
